import {
  CLIENT_ORDER_APPLY_COUPON_API,
  CLIENT_ORDER_AVAILABLE_TIME_API,
  CLIENT_ORDER_PAYMENT_API,
  CLIENT_ORDER_PAYMENT_GUEST_API,
  CLIENT_ORDER_PLACE_ORDER_API,
  CLIENT_ORDER_PLACE_ORDER_GUEST_API,
} from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import {
  IAppliedCouponModel,
  IAvailableDateModel,
  IConfirmCheckoutGuestModel,
  IConfirmCheckoutModel,
  IConfirmCheckoutResponseModel,
  IPlaceOrderGuestModel,
  IPlaceOrderModel,
} from "./order.models";

export const appliedCouponAPI = async (model: IAppliedCouponModel) => {
  return await apiClient.postHttp<number>(
    `${CLIENT_ORDER_APPLY_COUPON_API}`,
    model
  );
};
export const getAvailableDateAPI = async (branchId: number) => {
  return await apiClient.getHttp<IAvailableDateModel[]>(
    `${CLIENT_ORDER_AVAILABLE_TIME_API}`,
    {
      params: {
        branchId: branchId,
      },
    }
  );
};
export const placeOrderAPI = async (model: IPlaceOrderModel) => {
  return await apiClient.postHttp<string>(
    `${CLIENT_ORDER_PLACE_ORDER_API}`,
    model
  );
};

export const placeOrderGuestAPI = async (model: IPlaceOrderGuestModel) => {
  return await apiClient.postHttp<string>(
    `${CLIENT_ORDER_PLACE_ORDER_GUEST_API}`,
    model
  );
};
export const confirmCheckoutAPI = async (model: IConfirmCheckoutModel) => {
  return await apiClient.postHttp<IConfirmCheckoutResponseModel>(
    `${CLIENT_ORDER_PAYMENT_API}`,
    model
  );
};

export const confirmCheckoutGuestAPI = async (model: IConfirmCheckoutGuestModel) => {
  return await apiClient.postHttp<IConfirmCheckoutResponseModel>(
    `${CLIENT_ORDER_PAYMENT_GUEST_API}`,
    model
  );
};

